import React from 'react'
import './style.scss'

export default function Checkbox({ id, onChange, disabled }) {
	return (
		<>
			<label className="container calibri">
				<input
					onChange={onChange}
					id={id}
					type="checkbox"
					disabled={disabled}
				/>
				<span className="checkmark"></span>
			</label>
		</>
	)
}
